import "./App.css";
import { useEffect, useState } from "react";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const togglePrivacyPolicy = () => {
    setShowPrivacyPolicy(!showPrivacyPolicy);
  };

  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="StashScout - Your trusted online marketplace for discovering and comparing cannabis products from local dispensaries." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">StashScout · Your Cannabis Marketplace</p>
        <h1>Discover and Compare the Best Cannabis Products Near You</h1>
        <p className="lede">
          Make informed choices with StashScout, your trusted source for cannabis product comparisons and local dispensary reviews.
        </p>
        <div className="cta-row">
          <a href="/listings" className="primary">
            Browse Listings
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Product Comparisons</h2>
          <p>
            Easily compare cannabis products from various local dispensaries to find the best options for your needs.
          </p>
        </article>
        <article>
          <h2>Dispensary Reviews</h2>
          <p>
            Read honest reviews from fellow cannabis consumers to choose the right dispensary for your purchases.
          </p>
        </article>
        <article>
          <h2>Cannabis Education</h2>
          <p>
            Access valuable resources and information to enhance your understanding of cannabis and its benefits.
          </p>
        </article>
      </section>

      <footer>
        <button onClick={togglePrivacyPolicy}>Privacy Policy</button>
        {showPrivacyPolicy && (
          <div className="privacy-policy">
            <h2>Privacy Policy</h2>
            <p>
              At StashScout, we value your privacy. We collect data to enhance your experience on our platform, including analytics and cookies. 
              Third-party vendors, including Google AdSense, may use cookies to serve ads based on your prior visits to our site.
            </p>
            <p>
              You can manage your ad settings by visiting <a href="https://myaccount.google.com/data-and-privacy" target="_blank">Google's ad settings</a>.
            </p>
            <p>
              For any privacy-related questions, please contact us at support@stashscout.com.
            </p>
          </div>
        )}
      </footer>
    </div>
  );
}

export default App;